import {
    GiWeightLiftingUp,
    GiWeightLiftingDown,
    GiMuscleUp,
    GiBiceps,
    GiAbdominalArmor,
    GiLegArmor,
    GiPunchingBag,
    GiMeditation,
    GiStrongMan,
    GiHighKick,
    GiKneeling,
    GiJumpAcross,
    GiTeacher,
    GiPull,
    GiPulleyHook,
    GiChest,
    GiShoulderArmor,
    GiArm
} from 'react-icons/gi';
import { FaDumbbell, FaFire, FaChild } from 'react-icons/fa';
import { MdFitnessCenter, MdSelfImprovement, MdSportsMma } from 'react-icons/md';
import { IoBarbell, IoBody, IoFlash, IoWater } from 'react-icons/io5';
import { TbYoga, TbStretching, TbActivity, TbBarbell, TbBarbellFilled } from 'react-icons/tb';
import { BiBody, BiDumbbell } from 'react-icons/bi';

export const iconRepository = [
    // --- GYM & WEIGHTS (PALESTRA & PESI) ---
    {
        id: 'lift-1',
        name: { en: 'Weight Lifting', it: 'Sollevamento Pesi' },
        icon: GiWeightLiftingUp,
        tags: { en: ['strength', 'weights', 'gym'], it: ['forza', 'pesi', 'palestra'] }
    },
    {
        id: 'dumb-1',
        name: { en: 'Dumbbell', it: 'Manubrio' },
        icon: FaDumbbell,
        tags: { en: ['weights', 'strength', 'dumbbell'], it: ['pesi', 'forza', 'manubrio'] }
    },
    {
        id: 'tb-barbell',
        name: { en: 'Barbell', it: 'Bilanciere' },
        icon: TbBarbell,
        tags: { en: ['gym', 'weights', 'barbell'], it: ['palestra', 'pesi', 'bilanciere'] }
    },
    {
        id: 'barbell-row-1',
        name: { en: 'Barbell Row', it: 'Rematore Bilanciere' },
        icon: TbBarbellFilled,
        tags: { en: ['gym', 'back', 'row', 'barbell row'], it: ['palestra', 'schiena', 'rematore', 'rematore bilanciere'] }
    },
    {
        id: 'io-barbell',
        name: { en: 'Barbell Alt', it: 'Bilanciere Alt' },
        icon: IoBarbell,
        tags: { en: ['gym', 'weights', 'barbell'], it: ['palestra', 'pesi', 'bilanciere'] }
    },
    {
        id: 'bi-dumb',
        name: { en: 'Dumbbell Alt', it: 'Manubrio Alt' },
        icon: BiDumbbell,
        tags: { en: ['gym', 'weights', 'dumbbell'], it: ['palestra', 'pesi', 'manubrio'] }
    },
    {
        id: 'gym-1',
        name: { en: 'Fitness Center', it: 'Centro Fitness' },
        icon: MdFitnessCenter,
        tags: { en: ['gym', 'strength'], it: ['palestra', 'forza'] }
    },
    {
        id: 'lat-pulldown-1',
        name: { en: 'Lat Pulldown', it: 'Trazioni al Petto' },
        icon: GiWeightLiftingDown,
        tags: { en: ['gym', 'back', 'lat pulldown', 'pulldown', 'lats'], it: ['palestra', 'schiena', 'trazioni al petto', 'lat machine', 'dorsali'] }
    },
    {
        id: 'pulley-row-1',
        name: { en: 'Cable Row', it: 'Rematore al Pulley' },
        icon: GiPulleyHook,
        tags: { en: ['gym', 'back', 'cable row', 'pulley'], it: ['palestra', 'schiena', 'rematore al pulley', 'pulley', 'cavo'] }
    },
    {
        id: 'row-dumbbell-1',
        name: { en: 'Dumbbell Row', it: 'Rematore con Manubrio' },
        icon: GiPull,
        tags: { en: ['gym', 'back', 'row', 'dumbbell row'], it: ['palestra', 'schiena', 'rematore', 'rematore con manubrio'] }
    },
    {
        id: 'chest-dumbbell-1',
        name: { en: 'Chest Dumbbell Pull', it: 'Trazioni al Petto con Manubrio' },
        icon: BiDumbbell,
        tags: { en: ['gym', 'chest', 'dumbbell pull', 'upper back'], it: ['palestra', 'petto', 'trazioni al petto con manubrio', 'manubrio', 'schiena alta'] }
    },
    {
        id: 'chest-press-1',
        name: { en: 'Chest Press', it: 'Chest Press / Petto' },
        icon: GiChest,
        tags: { en: ['gym', 'chest', 'press'], it: ['palestra', 'petto', 'chest press', 'spinte petto'] }
    },
    {
        id: 'shoulder-press-1',
        name: { en: 'Shoulder Press', it: 'Shoulder Press' },
        icon: GiShoulderArmor,
        tags: { en: ['gym', 'shoulders', 'press'], it: ['palestra', 'spalle', 'shoulder press', 'spinte spalle'] }
    },
    {
        id: 'arnold-press-1',
        name: { en: 'Arnold Press', it: 'Arnold Press' },
        icon: GiWeightLiftingUp,
        tags: { en: ['gym', 'shoulders', 'arnold press', 'dumbbells'], it: ['palestra', 'spalle', 'arnold press', 'trazioni arnold', 'manubri'] }
    },
    {
        id: 'biceps-standing-1',
        name: { en: 'Standing Biceps Curl', it: 'Bicipiti in Piedi' },
        icon: GiBiceps,
        tags: { en: ['gym', 'arms', 'biceps', 'standing curl'], it: ['palestra', 'braccia', 'bicipiti', 'bicipite in piedi', 'curl in piedi'] }
    },
    {
        id: 'biceps-seated-1',
        name: { en: 'Seated Biceps Curl', it: 'Bicipiti da Seduto' },
        icon: GiArm,
        tags: { en: ['gym', 'arms', 'biceps', 'seated curl'], it: ['palestra', 'braccia', 'bicipiti', 'bicipite da seduto', 'curl da seduto'] }
    },

    // --- BODYWEIGHT & CALISTHENICS (CORPO LIBERO) ---
    {
        id: 'muscle-1',
        name: { en: 'Muscle Up', it: 'Muscle Up' },
        icon: GiMuscleUp,
        tags: { en: ['strength', 'calisthenics'], it: ['forza', 'calisthenics'] }
    },
    {
        id: 'pushup-1',
        name: { en: 'Push Ups (Gen)', it: 'Flessioni' },
        icon: IoBody,
        tags: { en: ['chest', 'pushups'], it: ['petto', 'flessioni'] }
    },
    {
        id: 'bi-body',
        name: { en: 'Body Workout', it: 'Allenamento Corpo' },
        icon: BiBody,
        tags: { en: ['calisthenics', 'body'], it: ['corpo libero', 'calisthenics'] }
    },
    {
        id: 'abs-1',
        name: { en: 'Abs Armor', it: 'Addominali (Armor)' },
        icon: GiAbdominalArmor,
        tags: { en: ['core', 'abs'], it: ['core', 'addominali'] }
    },
    {
        id: 'strong-1',
        name: { en: 'Core Strength', it: 'Forza Core' },
        icon: GiStrongMan,
        tags: { en: ['core', 'strength'], it: ['core', 'addominali'] }
    },
    {
        id: 'biceps-1',
        name: { en: 'Biceps Generic', it: 'Bicipiti Generici' },
        icon: GiBiceps,
        tags: { en: ['arms', 'strength', 'biceps'], it: ['braccia', 'forza', 'bicipiti'] }
    },

    // --- LEGS (GAMBE) ---
    {
        id: 'legs-1',
        name: { en: 'Legs/Armor', it: 'Gambe' },
        icon: GiLegArmor,
        tags: { en: ['legs', 'strength', 'squat'], it: ['gambe', 'forza', 'squat'] }
    },
    {
        id: 'kneel-1',
        name: { en: 'Lunges/Kneel', it: 'Affondi' },
        icon: GiKneeling,
        tags: { en: ['legs', 'squat', 'lunge'], it: ['gambe', 'squat', 'affondi'] }
    },
    {
        id: 'kick-1',
        name: { en: 'High Kick', it: 'Calcio Alto' },
        icon: GiHighKick,
        tags: { en: ['cardio', 'legs', 'kick'], it: ['cardio', 'gambe', 'calcio'] }
    },
    {
        id: 'jump-1',
        name: { en: 'Jump/Burpee', it: 'Salto/Burpee' },
        icon: GiJumpAcross,
        tags: { en: ['plyo', 'cardio', 'jump'], it: ['salto', 'cardio', 'burpees'] }
    },

    // --- YOGA & FLEXIBILITY (YOGA & STRETCHING) ---
    {
        id: 'yoga-1',
        name: { en: 'Meditation', it: 'Meditazione' },
        icon: GiMeditation,
        tags: { en: ['yoga', 'mind'], it: ['yoga', 'mente'] }
    },
    {
        id: 'tb-yoga',
        name: { en: 'Yoga (Tb)', it: 'Yoga (Tb)' },
        icon: TbYoga,
        tags: { en: ['yoga', 'flexibility'], it: ['yoga', 'flessibilità'] }
    },
    {
        id: 'stretch-1',
        name: { en: 'Stretching (Fa)', it: 'Stretching (Fa)' },
        icon: FaChild,
        tags: { en: ['flexibility', 'warmup'], it: ['flessibilità', 'riscaldamento'] }
    },
    {
        id: 'tb-stretch',
        name: { en: 'Stretching (Tb)', it: 'Stretching (Tb)' },
        icon: TbStretching,
        tags: { en: ['flexibility', 'clean'], it: ['flessibilità', 'clean'] }
    },
    {
        id: 'zen-1',
        name: { en: 'Zen/Balance', it: 'Zen/Equilibrio' },
        icon: MdSelfImprovement,
        tags: { en: ['yoga', 'mind'], it: ['yoga', 'mente'] }
    },

    // --- COMBAT (COMBATTIMENTO) ---
    {
        id: 'punch-1',
        name: { en: 'Boxing', it: 'Boxe' },
        icon: GiPunchingBag,
        tags: { en: ['combat', 'cardio'], it: ['combattimento', 'cardio'] }
    },
    {
        id: 'mma-1',
        name: { en: 'MMA', it: 'MMA' },
        icon: MdSportsMma,
        tags: { en: ['combat'], it: ['combattimento'] }
    },

    // --- UTILS & METRICS (UTILITÀ) ---
    {
        id: 'tb-act',
        name: { en: 'Activity', it: 'Attività' },
        icon: TbActivity,
        tags: { en: ['chart', 'metrics'], it: ['grafico', 'metriche'] }
    },
    {
        id: 'io-flash',
        name: { en: 'Energy/Hiit', it: 'Energia/Hiit' },
        icon: IoFlash,
        tags: { en: ['energy', 'hiit'], it: ['energia', 'hiit'] }
    },
    {
        id: 'water-1',
        name: { en: 'Hydration', it: 'Idratazione' },
        icon: IoWater,
        tags: { en: ['health'], it: ['salute'] }
    },
    {
        id: 'fire-1',
        name: { en: 'Burn', it: 'Brucia Grassi' },
        icon: FaFire,
        tags: { en: ['cardio', 'intense'], it: ['cardio', 'intenso'] }
    },
    {
        id: 'coach-1',
        name: { en: 'Coach', it: 'Allenatore' },
        icon: GiTeacher,
        tags: { en: ['general'], it: ['generale'] }
    }
];

export const getLocalizedIcon = (item) => {
    if (!item) return null;
    const userLang = navigator.language.split('-')[0];
    const lang = ['it', 'en'].includes(userLang) ? userLang : 'en';

    return {
        ...item,
        name: item.name[lang] || item.name['en'],
        tags: item.tags[lang] || item.tags['en']
    };
};

export const getIconById = (id) => {
    return iconRepository.find(item => item.id === id);
};
